import React from 'react'

export interface AccountDrawerContextType {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  accountId: string
  setAccountId: (accountId: string) => void
}

export const AccountDrawerContext = React.createContext<AccountDrawerContextType>({
  isOpen: false,
  setIsOpen: () => {},
  accountId: '',
  setAccountId: () => {}
})
